<fs-dialog>
  <fs-dialog-title>Switch Organization</fs-dialog-title>
  <mat-dialog-content>
    <fs-filter [config]="filterConfig"></fs-filter>
    <div class="fs-column environment-items">
      @for (environment of filteredEnvironments(); track environment.id) {
        <div class="environment-item" (click)="switch(environment)">
          <div class="fs-row.gap-sm">
            <fs-badge [shape]="'circle'" [size]="45" [image]="environment.image.small"></fs-badge>
            <div>{{ environment.name }}</div>
          </div>
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="null" type="button">Done</button>
  </mat-dialog-actions>
</fs-dialog>
